// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2Q50s","title":"ClientReferral_title__2DeH4","itemText":"ClientReferral_itemText__s9mZq"};